import { render, staticRenderFns } from "./PatientEditForm.vue?vue&type=template&id=377a6b2f"
import script from "./PatientEditForm.vue?vue&type=script&lang=js"
export * from "./PatientEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports